<template>
  <q-form
    @submit="onSubmit"
    class="q-gutter-md"
  >
    <q-input
      dense
      outlined
      type="email"
      ref="email"
      no-error-icon
      v-model="credentials.email"
      placeholder="E-mail do Reuni"
      autocorrect="off"
      autocapitalize="off"
      autocomplete="off"
      spellcheck="false"
      hide-bottom-space
      :rules="[
        () => $v.credentials.email.required || 'E-mail é obrigatório',
        () => $v.credentials.email.email || 'E-mail inválido'
      ]"
    >
      <template #prepend>
        <q-icon
          name="mdi-account"
          size="xs"
        />
      </template>

      <template #append>
        <q-icon
          size="xs"
          name="mdi-close"
          class="cursor-pointer"
          v-show="credentials.email"
          @click="credentials.email = ''"
        />
      </template>
    </q-input>

    <q-input
      dense
      outlined
      no-error-icon
      v-model="credentials.password"
      ref="password"
      placeholder="Senha"
      :type="isPassword ? 'password' : 'text'"
      :rules="[
        () => $v.credentials.password.required || 'Senha é obrigatória',
        () => $v.credentials.password.minLength || 'Senha inválida'
      ]"
    >
      <template #prepend>
        <q-icon
          name="mdi-shield-lock-outline"
          size="xs"
        />
      </template>

      <template #append>
        <q-icon
          size="xs"
          :name="isPassword ? 'mdi-eye-off' : 'mdi-eye'"
          class="cursor-pointer"
          @click="isPassword = !isPassword"
        />
      </template>
    </q-input>

    <div class="row items-center justify-between">
      <q-btn
        flat
        dense
        no-caps
        padding="0"
        :ripple="false"
        color="primary"
        label="Esqueceu a senha?"
        :to="authForgotRoute"
      />

      <q-btn
        flat
        dense
        no-caps
        padding="0"
        :ripple="false"
        color="primary"
        label="Primeiro Acesso?"
        :to="authSignUp"
      />

      <AuthSubmit
        label="Entrar"
        :loading="auth.loading"
      />
    </div>
  </q-form>
</template>

<script>
import { mapState } from 'vuex'
import { required, minLength, email } from 'vuelidate/lib/validators'
import { ACTION_SIGN_IN, ROUTE_AUTH_SIGN_UP, ROUTE_AUTH_PASSWORD_FORGOT } from '../constants'
import AuthSubmit from '../components/AuthSubmit'

export default {
  components: {
    AuthSubmit
  },

  data () {
    const { email } = this.$route.query

    return {
      isPassword: true,
      credentials: { email }
    }
  },

  mounted () {
    this.$nextTick().then(() => (
      this.credentials.email
        ? this.$refs.password.focus()
        : this.$refs.email.focus()
    ))
  },

  computed: {
    ...mapState({
      auth: ({ authStore }) => authStore
    }),

    authForgotRoute () {
      return { name: ROUTE_AUTH_PASSWORD_FORGOT, query: { email: this.credentials?.email } }
    },

    authSignUp () {
      return { name: ROUTE_AUTH_SIGN_UP, query: { email: this.credentials?.email } }
    }
  },

  validations: {
    credentials: {
      email: { required, email },
      password: { required, minLength: minLength(7) }
    }
  },

  methods: {
    onSubmit () {
      if (this.auth.loading) return
      this.$store.dispatch(ACTION_SIGN_IN, this.credentials)
    }
  }
}
</script>
